import { render, staticRenderFns } from "./ChatSystemBox.vue?vue&type=template&id=65122aca&scoped=true"
import script from "./ChatSystemBox.vue?vue&type=script&lang=js"
export * from "./ChatSystemBox.vue?vue&type=script&lang=js"
import style0 from "./ChatSystemBox.vue?vue&type=style&index=0&id=65122aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65122aca",
  null
  
)

export default component.exports